import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { JoinService } from '../../core/services/join/join.service';
import { ScriptService } from '../../core/services/script/script.service';
import { environment } from '../../../environments/environment';
import { scripts } from '../../shared/constants/script.constant';
import { resetUserToken, startUserSessionMonitor } from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-mailing-issue',
    templateUrl: './mailing-issue.component.html',
    styleUrls: ['./mailing-issue.component.scss'],
})
export class MailingIssueComponent implements OnInit, OnDestroy {
    env: string = environment.url;
    userData$ = new Subscription();
    address: any;
    referral_code: any;
    referral_link: any;
    adlibTag: any;
    fbPixelUs: any;
    fbPixelUsNoScript: any;
    fbPixelCanada: any;
    fbPixelCanadaNoScript: any;

    constructor(
        private readonly joinService: JoinService,
        private readonly renderer: Renderer2,
        private readonly scriptService: ScriptService
    ) {}

    ngOnInit(): void {
        resetUserToken();
        startUserSessionMonitor();
        if (environment.production && environment.shouldAddPixel) {
            // pixel scripts
            this.adlibTag = this.scriptService.loadJsScript(
                this.renderer,
                scripts.adlib
            );
            this.fbPixelUs = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-us']
            );
            this.fbPixelUsNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-us']
            );
            this.fbPixelCanada = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-canada']
            );
            this.fbPixelCanadaNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-canada']
            );
        }

        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                if (data?.shipping_info.is_fedex_pickup) {
                    this.address =
                        data?.shipping_info?.fedex_location?.location_name +
                            ', ' +
                            data?.shipping_info?.fedex_location?.address ||
                        'Unable to fetch FedEx Pickup location';
                    this.address = this.address.toUpperCase();
                    this.referral_code = data?.referral_code;
                    this.referral_link = data?.referral_link;
                } else {
                    let dat = [
                        data?.shipping_info.mailing_address_line,
                        data?.shipping_info.mailing_address_apartment_suite_no,
                        data?.shipping_info.mailing_address_city,
                        data?.shipping_info.mailing_address_state,
                        data?.shipping_info.mailing_address_country,
                        data?.shipping_info.mailing_address_zip,
                    ];
                    let notNullData = dat.filter((x) => x !== null && x !== undefined);
                    this.address = notNullData.join(' ');
                }
            });
    }

    ngOnDestroy(): void {
        this.userData$.unsubscribe();
        if (environment.production && environment.shouldAddPixel) {
            this.scriptService.removeScript(this.renderer, this.adlibTag);
            this.scriptService.removeScript(this.renderer, this.fbPixelUs);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelUsNoScript
            );
            this.scriptService.removeScript(this.renderer, this.fbPixelCanada);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelCanadaNoScript
            );
        }
    }
}
